<script>
import __ from "@/libraries/Translation";

import Alert from "@/components/Alert";

export default {
  components: {
    Alert
  },
  setup() {
    const isSuccess = window.room_rent.bank_success;
    return {
      isSuccess
    };
  }
};
</script>

<template>
  <article v-html="__('payment.success_message')" v-if="isSuccess" />
  <Alert v-else>
    {{ __("payment.error_message") }}
  </Alert>
</template>
